import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { resources, SupportedLanguages } from './locales';
var supportedLngs = SupportedLanguages.map(function (l) { return l; });
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    returnNull: false,
    resources: resources,
    fallbackLng: 'en',
    ns: ['translations'],
    defaultNS: 'translations',
    supportedLngs: supportedLngs,
    interpolation: {
        escapeValue: false,
    },
});
// TODO setup language manually
// if (CurrentLocale) i18n.changeLanguage(CurrentLocale);
export default i18n;
